import { useGetBetHistoryQuery } from '@/store/api/betApi';
import { isGuestUser } from '@/utils';
import { Link, useParams } from 'react-router-dom';

/** Compact list of the user's current bets on this event (desktop bet slip rail). */
const MyBets = () => {
  const isGuest = isGuestUser();
  const { eventId } = useParams();
  const { data } = useGetBetHistoryQuery(
    {
      betTime: 'CURRENT',
      eventId: Number(eventId),
      limit: 10,
    },
    { skip: isGuest }
  );
  const bets = data?.bets ?? [];

  return (
    <div className="border-t border-shell-border text-sm">
      <div className="grid grid-cols-[1fr_56px_64px] gap-2 px-4 py-2 text-xs text-shell-muted">
        <span>Matched Bet</span>
        <span className="text-right">Odds</span>
        <span className="text-right">Stake</span>
      </div>

      {bets.length === 0 ? (
        <p className="px-4 pb-4 pt-2 text-center text-xs text-shell-muted">No bets yet</p>
      ) : (
        bets.map((item) => (
          <div
            key={item.id}
            className={`grid grid-cols-[1fr_56px_64px] gap-2 border-l-4 border-t border-t-shell-border px-4 py-2 ${
              item?.betOn?.toUpperCase() === 'BACK' ? 'border-l-back' : 'border-l-lay'
            }`}
          >
            <span className="truncate text-shell-fg">{item?.selection ?? '-'}</span>
            <span className="text-right text-shell-fg">{item?.odds ?? '-'}</span>
            <span className="text-right text-shell-fg">{item?.amount ?? '-'}</span>
          </div>
        ))
      )}

      <Link
        to="/user/bet-history"
        className="block border-t border-shell-border px-4 py-2.5 text-center text-xs font-semibold text-gold hover:underline"
      >
        See more
      </Link>
    </div>
  );
};

export default MyBets;
